import types from '../actions/types';

const initialState = {
  coveragePlans: [],
  coverageModules: [],
};

const cleanableState = {
  coveragePlan : "1",
  coverageModule : 1,
};

const pyme = (state = {...initialState, ...cleanableState}, action) => {
  switch (action.type) {

    case types.CLEAN:
      return { ...state, ...cleanableState};
      
    case types.SET_PYME_VALUE: {
      const { type, value } = action.payload;
      return {
        ...state,
        [type]: value
      }
    };

    case types.SET_PYME_LIST: {
      const { type, list } = action.payload;
      return {
        ...state,
        [type]: list
      }
    };

    default:
      return state;
  }
};

export default pyme;
